import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

customerAddressFormStyles.cancelButton = {
    css: css`
        margin-right: 10px;
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
    `,
};

customerAddressFormStyles.submitButton = {
    css: css`
        border-radius: 25px;
        border: 1px solid ${getColor("warning")};
        background-color: ${getColor("warning")};
        > span {
            color: ${getColor("info.contrast")} !important;
            font-family: ${TYPOGRAPHY.fontFamily.base};
        }
        &:hover {
            border: 1px solid ${getColor("warning.contrast")};
            background-color: ${getColor("warning.contrast")};
        }
    `,
};
